<template lang="html">
  <div>
    <component :is="paymentFormComponent"
               :doc="doc"
               :source-account-number="sourceAccountNumber"
               :overwrite-values="overwriteValues"
               @created="onModelCreated"
               @model-loading-start="onModelLoadingStart"
               @model-loaded="onModelLoaded"
               @model-submit-start="onModelSubmitStart"
               @document-created="onDocumentCreated"
               @model-submitable="onModelSubmitable"
               @model-invalidated="onModelInvalidated"
               @source-account-update="onSourceAccountUpdate"
               @model-loading-fail="onModelLoadingFail"
               @from-account-update="onFromAccountUpdate"
               @model="onModelInited"
               ref="form"></component>
    <form v-if="submitable">
      <div class="form-group" style="margin-top: 2em;"><span class="control-label">&nbsp;</span>
        <div class="dropdown" style="width: 370px;"><a href="#" @click.prevent="submit"
                                                       class="btn btn-success">
          {{ $t('Далее') }}
        </a></div>
      </div>
    </form>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import {ModelEvents} from 'capitalist-shared/src/core/model';
import {ImplementedPaymentForms} from "capitalist-shared/src/finance/payments";
import {paymentFormsConfig} from "@/views/pages/finance/payout/payout-forms";
import PayoutNoneForm from "@/components/forms/payout/forms/none/PayoutNoneForm.vue";
import AbstractPayoutForm from "@/components/forms/payout/abstract/AbstractPayoutForm.vue";


@Component({
  name: "PayoutFormWrapper",
  components: (() => {
    const result = {
      'payout-none': PayoutNoneForm,
    };
    Object.entries(paymentFormsConfig).forEach(([code, component]) => {
      result['payout-' + code] = component;
    });
    return result;
  })()
})
export default class PayoutFormWrapper extends Vue {
  @Prop({default: null, type: String || null})
  system: string | null

  @Prop({default: ''})
  sourceAccountNumber: string

  @Prop({default: null})
  doc: any | null

  @Prop({
    default: function () {
      return {}
    }
  })
  overwriteValues: any

  onModelInited(model: any) {
    this.$emit('model', model);
  }

  onFromAccountUpdate(account: any) {
    this.$emit('from-account-update', account);
  }

  getModel() {
    // console.log('PayoutFormWrapper getModel', (this.$refs.form as AbstractPayoutForm)?.getModel());
    return (this.$refs.form as AbstractPayoutForm)?.getModel();
  }

  systems: string[] = ImplementedPaymentForms

  submitable = false

  setSourceAccountNumber(accountNumber: string) {
    if (this.$refs.form)
      (this.$refs.form as AbstractPayoutForm).setSourceAccountNumber(accountNumber);
  }

  fillTemplate(template: any) {
    if (this.$refs.form)
      (this.$refs.form as AbstractPayoutForm).fillTemplate(template);
  }

  onModelCreated(submitable: boolean = false) {
    this.submitable = submitable;
  }

  onModelLoadingFail() {
    this.$emit(ModelEvents.modelLoadingFail);
  }

  onModelInvalidated() {
    this.$emit(ModelEvents.modelInvalidated);
  }


  onModelSubmitStart(model: any) {
    this.$emit(ModelEvents.modelSubmitStart, model);
  }

  onModelSubmitable(value: boolean) {
    this.submitable = value;
  }

  onModelLoadingStart() {
    this.$emit(ModelEvents.modelLoadingStart);
  }

  onModelLoaded(model?: any) {
    if (this.$i18n && ['ru', 'en'].includes(this.$i18n.locale)
      && model?.values) {
      model.values.notificationLanguage = this.$i18n.locale;
    }

    this.$emit(ModelEvents.modelLoaded, model);
  }

  onSourceAccountUpdate(account: any) {
    this.$emit(ModelEvents.sourceAccountUpdate, account);
  }

  submit() {
    (this.$refs.form as any).submit();
  }

  onDocumentCreated(document: any, model: any, verificationModel: any) {
    this.$emit(ModelEvents.documentCreated, document, model, verificationModel);
  }

  reset(values?: any) {
    (this.$refs.form as any).reset(values);
  }

  reload() {
    (this.$refs.form as any).load();
  }

  get paymentFormExist(): boolean {
    return this.systems.indexOf(this.system) > -1;
  }

  get paymentFormComponent(): string {
    return this.paymentFormExist ? 'payout-' + this.system : 'payout-none';
  }
}
</script>

<style scoped>

</style>

<i18n>
{
  "en": {
    "Далее": "Next"
  }
}
</i18n>
